export default __webpack_public_path__ + "static/media/app2-10.885bc789.jpg";